import { useLocation, matchPath } from "react-router-dom";
import { LinearProgress } from "@mui/material";
import { useHMG } from "../../../HMGContext";

const QUEUED_MESSAGE = "Queued for COA alignment…";
const RUNNING_MESSAGE = "Aligning this version to the latest COA…";
const FAILED_MESSAGE = "COA alignment failed. This plan is read-only — please contact support.";
const QUEUED_STATUS = "PENDING";

/**
 * Plan-scoped counterpart of HMGReprocessingLoader: shown only on the details page of the plan whose
 * save-as-new-version COA alignment is running (or failed). The plan details page owns the state
 * (HMGContext.planReprocessStatus) and clears it on leave, so the card disappears with the page.
 */
const PlanReprocessingLoader = () => {
  const { planReprocessStatus } = useHMG();
  const location = useLocation();
  const currentPlanId = matchPath("/planVersion/:id", location.pathname)?.params?.id ?? null;

  if (!planReprocessStatus?.locked || currentPlanId == null
    || String(planReprocessStatus.planId) !== String(currentPlanId)) {
    return null;
  }

  const { failed, status } = planReprocessStatus;

  return (
    <div className="p-4 bg-[#CAFDF5] shadow-[0px_4px_16px_0px_#00000040] rounded-lg max-w-md">
      <div>
        <div className="flex justify-between items-center">
          <span className="text-xs font-semibold text-[#637381] leading-[18px]">
            {failed ? "Reprocessing failed" : "Reprocessing"}
          </span>
        </div>

        <div className="flex items-center gap-3 justify-between my-1">
          <span className={`${failed ? "text-[#B71D18]" : "text-[#212B36]"} text-sm leading-[22px]`}>
            {failed ? FAILED_MESSAGE : status === QUEUED_STATUS ? QUEUED_MESSAGE : RUNNING_MESSAGE}
          </span>
        </div>

        {!failed && (
          <LinearProgress
            variant="indeterminate"
            sx={{
              width: "300px",
              height: 8,
              borderRadius: 9999,
              backgroundColor: "#FFFFFF",
              "& .MuiLinearProgress-bar": { backgroundColor: "#00B8D9", borderRadius: 9999 },
            }}
          />
        )}
      </div>
    </div>
  );
};
export default PlanReprocessingLoader;
